export const ADD_ACTIVITIES = "ADD_ACTIVITIES";